import { auth, callable } from '$lib/firebase/firebase';
import { showLoader } from '@repo/stores/Actions';
import { deleteStore as deleteGhostStore } from '@repo/stores/Ghost.js';

/**
 * End the current impersonation session and close the tab.
 *
 * TAP only enters an impersonation session via the admin-app handoff, so this
 * always runs in the new tab the admin opened. We don't redirect back to the
 * Auth app (the admin is still signed in on their own tab) — we just sign out
 * locally and close the tab.
 */
export async function stopImpersonating() {
    showLoader.set('Stopping Impersonation');

    try {
        const stopImpersonationFn = callable('stopImpersonation');
        await stopImpersonationFn();
    } catch (err) {
        console.error('[tap-impersonation] stopImpersonation call failed', err);
    }

    // Revoke refresh tokens server-side so the impersonated session can't be
    // renewed from any other origin that may have cached it.
    try {
        const revokeUserTokens = callable('revokeUserTokens');
        await revokeUserTokens();
    } catch (err) {
        console.error('[tap-impersonation] revokeUserTokens failed', err);
    }

    try {
        await auth.signOut();
    } catch (err) {
        console.error('[tap-impersonation] auth.signOut failed', err);
    }

    deleteGhostStore();
    showLoader.set(false);

    window.close();
}
